import React, { useRef, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Spinner } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import FormField from '../../form/fields/FormField';
import { AvForm } from 'availity-reactstrap-validation';
import { fetchMe, fetchOnAuthenticated } from '../../../../redux/me/me.actions';
import { connect } from 'react-redux';
import TipField from '../../form/fields/CustomTipField';
import FormattedNumberField from '../../form/fields/FormattedNumberField';

const CustomTipModal = ({ isOpen, closeModal, handleSaveTip }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const intl = useIntl();
  return (
    <Modal
      isOpen={isOpen}
      toggle={closeModal}
      className="modal-dialog-centered"
      style={{ zIndex: 9000 }}
    >
      <AvForm
        onSubmit={(event, errors, values) => {
          if (errors.length === 0) {
            handleSaveTip(values?.tip);
            closeModal();
          }
        }}
      >
        <ModalHeader toggle={closeModal}>
          <FormattedMessage id="customTipTitle" />
        </ModalHeader>
        <ModalBody>
          <FormattedNumberField
            placeholder={intl.formatMessage({ id: 'tipTitle' })}
            noLabel={true}
            propName="tip"
          />
          <Button
            data-testid="saveButton"
            className="w-100"
            color="primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <Spinner color="white" size="sm" />
                <span className="ml-50">
                  <FormattedMessage id="loading" />
                </span>
              </>
            ) : (
              <FormattedMessage id="save" />
            )}
          </Button>
        </ModalBody>
      </AvForm>
    </Modal>
  );
};

CustomTipModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  titleId: PropTypes.string,
  messageId: PropTypes.string,
  handleRemoval: PropTypes.func,
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  fetchMe,
  fetchOnAuthenticated,
})(CustomTipModal);
